export const REDUCER_NAME = 'task-list-with-attachment'




// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/state/const.js